import React from "react";
import { Badge, Box, LinkButton, Typography } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";
import getEnvironment from "../../getEnvironment";

const Container = styled(Box)`
  ${css({
    borderBottom: "2px solid",
    borderColor: "primary-navy-blue",
  })}
`;

const PaymentDue = () => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const href = isProd
    ? "https://www.bca.co.uk/buy/paying-with-bca/bank-transfer"
    : "https://cms.uat.britishcarauctions.net/buy/paying-with-bca/bank-transfer";

  return (
    <Container
      backgroundColor="rgba(233, 245, 254, 0.5);"
      paddingX={{
        mobile: "20px",
        desktop: "48px",
      }}
      paddingY="32px"
    >
      <Box paddingBottom="20px">
        <Badge label="Payment Due" variant="neutral" />
      </Box>
      <Box>
        <Typography variant="body-small">
          Pay for invoices <strong>up to</strong> the value of{" "}
          <strong>£250,000</strong> online, check with your bank for the limits
          set on your account.You can also pay by bank transfer, for more
          details see our{" "}
          <LinkButton
            href={href}
            color="text-color-hover"
            shouldOpenInNewWindow
            variant="tertiary"
            css="
            text-decoration: underline;"
            padding={0}
            height={4}
            fontWeight="bold"
            fontSize="body-small"
            data-en="click"
            data-ec="button"
            data-el="bank-transfer-guide"
            data-ea="navigate"
            data-es=""
          >
            guide to bank transfer
          </LinkButton>
          .
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentDue;
